module.exports = __webpack_public_path__ + "img/中国报道新闻网_01.7d58ece6.jpg";